export type AllyView =
  | "agent"
  | "new-tasks"
  | "whatsapp"
  | "docs"
  | "tasks";

const VALID_VIEWS: AllyView[] = [
  "agent",
  "new-tasks",
  "whatsapp",
  "docs",
  "tasks",
];

export function isAllyView(value: string | null | undefined): value is AllyView {
  return !!value && (VALID_VIEWS as string[]).includes(value);
}
